export const sortLocationsByDescTotalAmount = (a, b) => {
  return (a.totalAmount < b.totalAmount) ? 1 : ((b.totalAmount < a.totalAmount) ? -1 : 0);
};